<template>
  <div>
    <van-nav-bar 
    left-text="返回"
          left-arrow
          fixed
          @click-left="goHome"
      style="position:fixed;width:100%">
        <template #title>
          <span>直接调拨</span>
        </template>
      </van-nav-bar>

    <van-row style="padding-top:60px">
        <van-form ref="checkbox">
          <van-cell-group inset>

            <van-field
              v-model="productId"
              name="品号"
              label="品号"
              placeholder="品号"
            >
              <template #button>
                <van-icon name="search" size="24" @click="searchProduct" style="font-size:24px;color:#0D79C4"/>
                <van-icon name="scan" size="24" @click="scanProduct" style="font-size:24px;margin-left:2px"/>
               
              </template>
            </van-field>

            <van-field
                v-model="batchId"
                name="批号"
                label="批号"
                placeholder="批号"
              >
              </van-field>

            <van-field
              v-model="productName"
              name="品名"
              label="品名"
              disabled 
              placeholder=""
              clearable
            >
            </van-field>

          

           
              <van-field
              v-model="outStore.name"
              name="转出仓"
              label="转出仓"
              placeholder=""
              disabled
              clearable
            >
              <template #button>
                <van-icon name="delete" size="24" @click="()=> { outStore = { id:'', name:'' }}" style="font-size:24px"/>
                <van-icon name="search" size="24" @click="$refs.outStoreSelectDialog.open()" style="font-size:24px;margin-left:4px;"/>
              </template>
            </van-field>

              <van-field
              v-model="store.name"
              name="转入仓"
              label="转入仓"
              placeholder=""
              disabled
              clearable
            >
              <template #button>
                <van-icon name="delete" size="24" @click="()=> { store = { id:'', name:'' }}" style="font-size:24px"/>
                <van-icon name="search" size="24" @click="$refs.storeSelectDialog.open()" style="font-size:24px;margin-left:4px;"/>
              </template>
            </van-field>

            <van-field
                v-model="count"
                name="数量"
                label="数量"
                placeholder="数量"
              >
                <template #button>
                  <van-icon name="edit" size="24" @click="addItem" style="font-size:24px"/>
                </template>
              </van-field>

          </van-cell-group>
        </van-form>
      </van-row>

      <van-row style="padding-top:10px">
          <van-list  
            style="overflow: scroll;padding:0 20px;overflow-y: auto;"
            :style="{ height:innerHeight}"
          >
              <van-cell v-for="(item,index) in filterProduct" :key="index" title="" style="margin:10px 0" :class="item.select?'select':'unselect'">
                <!-- 使用 right-icon 插槽来自定义右侧图标 -->
                <template #label>
                  <div @click="selectItem(item)" >
                    <van-row >
                      <div class="content">
                        <van-col span="24">{{ item.productName }}【{{item.productId}}】
                           <span v-if="item.scaned" style="float:right;color:red;float:right">待提交</span>
                        </van-col>

                        <van-col span="12" style="margin-top:4px">
                          规格:{{item.spec}}
                        </van-col>
                        <van-col span="12" style="margin-top:4px">
                          批号:{{item.batchId}}
                        </van-col>
                        <van-col span="12" style="margin-top:4px">
                          数量:
                          <span v-if="!item.editing"> {{item.submitCount || 0}} </span>
                        </van-col>
                        <van-col span="12" style="margin-top:4px">
                          单位:{{item.unit}}
                        </van-col>
                        <van-col span="12" style="margin-top:4px">
                          转出库:{{item.mainStoreName}}
                        </van-col>
                        <van-col span="12" style="margin-top:4px">
                          转入库:{{item.enterStoreName}}
                        </van-col>
                        
                      </div>
                    </van-row>
                    <van-row>
                      <van-col span="24" style="height:20px" v-if="!item.editing">
                       <span style="position:absolute;color:#1989fa;right:16px;" @click.stop="deleteItem(item)">删除</span>
                        <van-icon  style="position:absolute;margin-top:1px;margin-right:2px;right:42px;" name="delete" size="16" color="#1989fa"/>
                      </van-col>
                    </van-row>
                  </div>
                </template>
            </van-cell>
           
        </van-list>
      </van-row>

      <van-row style="padding:20px">
          <van-button round   size="large" type="info" @click="submit" style="height:30px;" >提交</van-button>
      </van-row>

      <StoresSelectDialog
        isSingle = true
        ref="storeSelectDialog"
        @select="
          (data) => {
            updateStore(data);
            $forceUpdate();
          }
        "
      ></StoresSelectDialog>

      <StoresSelectDialog
        isSingle = true
        ref="outStoreSelectDialog"
        @select="
          (data) => {
            updateOutStore(data);
            $forceUpdate();
          }
        "
      ></StoresSelectDialog>
  </div>
</template>
  
  <script>
import Vue from 'vue'
import { router }  from '../../../router'
import qywxUtil from '../../../util/jweixin/index'
import { getProductDetail,submit } from '../../../api/wms/absoluteAllocate/index'
import { Toast,Dialog} from 'vant';
import { guid } from '../../../util/uuid.js'
import {checkStoreProp ,isProductEnableBatch } from '../../../api/wms/index'

export default {
    components: {

    },
    computed: {
    },
    data() {
      return {
        innerHeight:window.innerHeight - 420 + 'px',
        productId:'',
        productName:'',
        count:null,
        selectedItem:null,
        list:[],
        batchId:'',
        store:{
          id:'',
          name:'',
          prop:''
        },
        outStore:{
          id:'',
          name:'',
          prop:''
        }
      };
    },
    computed:{
      filterProduct(){
        if(this.productId == null || this.productId == '' ){
          return this.list;
        }
        return this.list;//.filter(o=> o.productId.indexOf(this.productId) != -1||o.scaned);
      }
    },
    mounted(){
      if('development' != process.env.NODE_ENV)
      qywxUtil.init();
    },
    methods: {
      initialData(){
       
        this.productId = '';
        this.productName = '';
        this.count = null;
        this.selectedItem = null;
        this.list = [];
        this.store = {
          id:'',
          name:'',
          prop:''
        };
        this.outStore = {
          id:'',
          name:'',
          prop:''
        }
      },
      updateStore(data){
        if(data.id == this.store.id){
          return;
        }

        //初始化数据
        this.store = data;
      },
      updateOutStore(data){
        if(data.id == this.outStore.id){
          return;
        }

        //初始化数据
        this.outStore = data;
      },
      initialProductItemInfo(){
        this.getDetail();
        //如果当前已选择一个，则过滤
        this.productName = '';
        this.count = 0;

        //1、查找品号对应品名
        
        var productList = this.list.filter(o=> o.productId == this.productId);
        if(productList.length > 0) {
          this.productName = productList[0].productName;
        }
          


        this.list.sort((a,b)=>{
            var oa = a.select?1:0;
            var ob = b.select?1:0;
            var result = ob-oa;

            return result;
          });

  
        //如果当前选择的与品号不同，默认选择第一个相同的品号
        this.$forceUpdate();
      },
      selectItem(item){
        this.list.forEach(o=>{
          delete o.select;
        });
        
       // item.select = 'select';

        
        this.selectedItem = item;
        this.selectedItem.select = 'select';

        this.productId = item.productId;
        this.productName = item.productName;
        this.count = item.submitCount;
        this.store = {
          id:item.enterStore,
          name:item.enterStoreName,
        };

        this.outStore = {
          id:item.mainStore,
          name:item.mainStoreName,
        };

        this.$forceUpdate();
      },
      async getDetail(){
        if(this.productId == null || this.productId == '')
          return;

        //保存当前待提交的item
        var unSubmitList = this.list.filter(o=> o.scaned == true);

        var res = await  getProductDetail(this.productId);

        this.list = res.data;
          this.list.forEach(i=>{
            i.submitCount = 0;
            i.editing = false;
            i.select = null;
            i.id = guid();
          })

          this.productName = this.list[0].productName;

          if(res.data.length > 0){
            this.outStore = {
              id: this.list[0].mainStore,
              name:this.list[0].mainStoreName
            }

            this.store = {
              id: '',
              name:''
            }

            this.selectedItem = this.list[0];
  
            this.selectedItem.select = 'select';
          }

          console.log(this.list)

          if(unSubmitList.length >0){
            unSubmitList.forEach(o=>{
              delete o.select;
            })
            this.list = this.list.concat(unSubmitList)
          }

          console.log(this.list)

          this.$forceUpdate();
      },
      async addItem(){
        if(Number.isNaN(parseFloat(this.count))){
            Toast('输入数量不合法!');
            return;
          }

          if(this.count <= 0){
            Toast('输入数量应大于0!');
            return;
          }

        if(!this.store.id || this.store.id == ''){
          Toast('必须选择入库仓库!');
          return;
        }

        if(!this.outStore.id || this.outStore.id == ''){
          Toast('必须选择出库仓库!');
          return;
        }

        var res = (await checkStoreProp(this.store.id,this.outStore.id)).data;

        if(res == false){
          Toast('不同性质仓库间不可以调拨!');
          return;
        }


        this.selectedItem.submitCount = parseFloat( this.count) ;

        this.selectedItem.enterStore = this.store?this.store.id:'';
        this.selectedItem.enterStoreName = this.store?this.store.name:'';

        this.selectedItem.mainStore = this.outStore?this.outStore.id:this.selectedItem.mainStore;
        this.selectedItem.mainStoreName = this.outStore?this.outStore.name:this.selectedItem.mainStoreName;

        this.selectedItem.batchId = this.batchId;

        this.selectedItem.scaned = true;
        this.$forceUpdate();

        this.productId = '';
        this.productName = '';
        this.count = null;
        this.selectedItem = null;
        this.batchId = '';
        this.store = {
          id:'',
          name:''
        };
        this.outStore = {
          id:'',
          name:''
        }
      },
      deleteItem(item){
        Dialog.confirm({
            title: '确认删除',
            message:
              '确认删除当前调拨？',
          })
          .then(() => {
           // var index = this.
           var index = this.list.findIndex(o=> o.id == item.id);
           
           this.list.splice(index,1);

            this.$forceUpdate();
          })
      },
      submit(){
        var scanedList = this.list.filter(o=> o.scaned == true && parseFloat(o.submitCount) > 0 );

        if(scanedList.length == 0) return;

        var data = {
        }

        data.details = [];
       
        this.list.forEach(o=>{

          if(o.scaned == true &&  parseFloat(o.submitCount) > 0 )
          
          data.details.push({
            productId:o.productId,
            productName:o.productName,
            mainStore:o.mainStore,
            enterStore:o.enterStore,
            unit:o.unit,
            spec:o.spec,
            count:parseFloat(o.submitCount),
            back:o.back,
            woIndex:o.index,
            batchId:o.batchId
          })
        })

        submit(data).then(res=>{
          if(res.code == 200){
            if(res.message == "" || res.message == "操作成功!"){
                Toast('操作成功!');
                
              }
              else {
                Toast({
                  message: res.message,
                  duration:3000
                });
              }

              this.initialData();
              this.list = [];
              this.$forceUpdate();
          }
          else{
            Toast('操作失败,'+ res.message);
          }
        })
      },
      async scanProduct(){
        var scanResult = await this.$sysUtil.scan(); 
        var id = scanResult;

        var data = id.split('|')
          if(data.length == 1){
            this.productId = data[0];
            this.batchId = '********************';
          }
          else if(data.length == 2){
            this.productId = data[0];
            this.batchId = data[1];
          }

          var res =  (await isProductEnableBatch(this.productId)).data;
          if(res == true && this.batchId == '********************'){
            Toast({
              message: '启用批号管理的商品批号不允许为空!',
              duration:3000
            });
            return;
          }

        this.initialProductItemInfo();
      },
      async searchProduct(){
          this.list.forEach(o=>{
            delete o.select;
          });
          this.selectedItem = null;


          if(this.batchId == ''){
            this.batchId = '********************';
          }

          var res =  (await isProductEnableBatch(this.productId)).data;
          if(res == true && this.batchId == '********************'){
            Toast({
              message: '启用批号管理的商品批号不允许为空!',
              duration:3000
            });
            return;
          }

        this.initialProductItemInfo();
        },
      goHome(){
        this.$router.push({
            path:'/home',
            query:{
              active:3
            }
          });
      }
    }
  }; 
  </script>
  
<style scoped>
.select{
  border:1px solid rgb(255, 56, 30)
}

.content{
  font-size:14px;
  color:#323233
}
</style>

<style lang="less" scoped>
.van-field__label{
width:3.2em !important;
}
</style>
